<template>
  <div>
    <div class="br-5 mt-4 text-center connection-lost-wrapper mx-auto" data-cy="loading-problems-screen">
      <div>
        <img src="/img/miscellaneous/ui/no-connection.svg"
             alt=""
             class="mb-4 pb-2"
             loading="lazy"
        />

        <h2>{{ $t('ui.connection_lost.header') }}</h2>

        <p class="gray-300">{{ $t('ui.connection_lost.check_internet') }}</p>

        <p class="gray-300 mb-4 pb-2">{{ $t('ui.connection_lost.different_cause') }}</p>
      </div>

      <!--eslint-disable-next-line sdui/require-focus-restore-on-disabled-button-->
      <b-button :disabled="refetching"
                variant="primary"
                block
                size="lg"
                @click="triggerRefetch"
      >
        {{ $t('ui.connection_lost.button_text') }}
      </b-button>

      <SLink appearance="b-button"
             :disabled="refetching"
             variant="link"
             block
             size="lg"
             :href="$t('global.status_page')"
      >
        {{ $t('ui.connection_lost.open_status_page') }}
      </SLink>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SduiLoadingProblem',
  data: () => ({
    refetching: false,
  }),

  computed: {
    moreInfoLink() {
      return this.$t('ui.connection_lost.more_info_link')
    },
  },

  emits: ['refetch'],

  methods: {
    triggerRefetch() {
      this.refetching = true
      const self = this
      setTimeout(() => {
        self.refetching = false
        self.$emit('refetch')
      }, 1000)
    },
  },

  created() {},
}
</script>

<style scoped lang="scss">
.connection-lost-wrapper {
  max-width: 340px;
}
</style>
